import { UIDContext } from "@prismicio/editor-fields"
import { type ReactNode, useMemo, useRef } from "react"

interface Props {
  children: ReactNode
}

export function UIDProvider(props: Props) {
  const { children } = props

  const editedUID = useRef(false)

  const value = useMemo(
    () => ({
      editedUID,
      onEditUID: () => {
        editedUID.current = true
      }
    }),
    []
  )

  return <UIDContext.Provider value={value}>{children}</UIDContext.Provider>
}
